async function setupMap(mapEl, data) {
  const { Map } = await google.maps.importLibrary('maps')
  const { Marker } = await google.maps.importLibrary('marker')

  const position = {
    lat: data.lat,
    lng: data.lng,
  }

  const map = new Map(mapEl, {
    zoom: 16,
    center: position,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    scrollwheel: false,
    gestureHandling: 'none',
    styles: [
      {
        featureType: 'all',
        elementType: 'all',
        stylers: [{ saturation: -100 }],
      },
    ],
  })

  const marker = new Marker({
    map: map,
    title: 'Get Directions',
    position,
    panPosition: position,
  })

  if (data.url) {
    marker.addListener('click', () => {
      window.open(data.url, '_blank')
    })
  }
}

document.querySelectorAll('.element-contactmap').forEach((el) => {
  const mapEl = el.querySelector('.google-map-container')
  const data = JSON.parse(mapEl.dataset.json)

  setupMap(mapEl, data)
})
